import { Text } from 'react-native';

export function Loading() {
  return <Text>Loading</Text>;
}
